import { handleActions } from "redux-actions";

const initialState = {
    data: [],
    loading: false,
    error: null
}

export default handleActions({
    UPDATE_TOKENS: (state, action) => ({
        ...initialState,
        data: action.payload
    })
}, initialState)